import { MousePointerClick } from 'lucide-react';

export type TriggerType = 'attribute-segment' | 'event';

export interface TriggerNodeProps {
  triggerType?: TriggerType;
  event?: string;
  hasConditions: boolean;
  formattedConditions: string;
  onChooseTrigger: () => void;
}

const TriggerNode = ({
  triggerType = 'attribute-segment',
  event = '',
  hasConditions,
  formattedConditions,
  onChooseTrigger,
}: TriggerNodeProps) => {
  const isEventTrigger = triggerType === 'event';
  const hasChosenTrigger = isEventTrigger
    ? Boolean(event?.trim())
    : hasConditions;

  if (!hasChosenTrigger) {
    return (
      <button
        onClick={onChooseTrigger}
        type="button"
        className="mt-1 px-3 py-1.5 bg-primary text-primary-foreground text-xs font-medium rounded-lg hover:opacity-90 transition-opacity w-full"
      >
        Choose trigger
      </button>
    );
  }

  if (isEventTrigger) {
    return (
      <div className="text-xs text-muted-foreground p-4 space-y-3 !mt-0">
        <div
          className="inline-flex items-center rounded-lg border border-border bg-muted px-2"
          title={event}
        >
          <div className="flex-shrink-0 w-8 h-8 rounded-md flex items-center justify-center text-primary">
            <MousePointerClick className="w-4 h-4" aria-hidden />
          </div>
          <p className="font-medium text-foreground truncate min-w-0">
            {event}
          </p>
        </div>
        {hasConditions && formattedConditions && (
          <p className="line-clamp-2 text-muted-foreground">
            {formattedConditions}
          </p>
        )}
      </div>
    );
  }

  return (
    <p className="text-xs text-muted-foreground line-clamp-2 p-4 !mt-0">
      {formattedConditions}
    </p>
  );
};

export default TriggerNode;
